module.exports = "/fonts/SFUIText-Regular.woff?df14d76c032f4038346697b1dc32c562";